import { PropTypes } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Heading from '@bibliocommons/heading';
import { Table, TableHeader, TableHeading, TableBody, TableRow, TableCell } from '@bibliocommons/table';

import { ROUTE } from 'app/constants/AdminBrowseConstants';

const AdminBrowseHomePage = ({ browseHomePages }) => {
  return (
    <div className="cp-admin-browse-home-page container">
      <Heading size="large" tagName="h1" variant>
        Browse Home
      </Heading>

      <Table>
        <TableHeader>
          <TableHeading>ID</TableHeading>
          <TableHeading>Title</TableHeading>
          <TableHeading />
        </TableHeader>
        <TableBody>
          {browseHomePages.map(browseHomePage => {
            const { browseHomePageId, title } = browseHomePage;

            return (
              <TableRow key={browseHomePageId}>
                <TableCell>{browseHomePageId}</TableCell>
                <TableCell>{title}</TableCell>
                <TableCell>
                  <Link
                    dataKey={`${ROUTE.ADMIN_BROWSE_HOME_EDIT}/${browseHomePageId}`}
                    to={`${ROUTE.ADMIN_BROWSE_HOME_EDIT}/${browseHomePageId}`}
                  >
                    Edit
                  </Link>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

AdminBrowseHomePage.propTypes = {
  browseHomePages: PropTypes.arrayOf(
    PropTypes.shape({
      browseHomePageId: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};

export default AdminBrowseHomePage;
